import { CloseWasteContainerDto, WasteContainerDto } from '@services/dtos'
import { useAppDispatch } from '@hooks/reduxHooks'
import { closeWasteContainer } from '@state/reducers/wasteContainerReducer'
import { WasteContainerMeasurementDialog } from './WasteContainerMeasurementDialog'

type Props = {
  open: boolean
  container: WasteContainerDto
  onClose: () => void
}

export function CloseWasteContainerDialog({ open, container, onClose }: Props) {
  const dispatch = useAppDispatch()

  const handleSubmit = (dto: CloseWasteContainerDto) =>
    dispatch(closeWasteContainer({ id: container.id, dto })).unwrap()

  return (
    <WasteContainerMeasurementDialog
      open={open}
      container={container}
      onClose={onClose}
      title={`Fermer le conteneur #${container.no}`}
      successMessage="Conteneur fermé avec succès"
      errorMessage="Une erreur est survenue lors de la fermeture"
      onSubmit={handleSubmit}
    />
  )
}
